import { useEffect, useRef, useState } from "react";
import { motion } from "motion/react";
import useIsMounted from "../../hooks/useIsMounted";
import { Helmet } from "react-helmet";
import sleepUntil from "../../utils/sleepUntil";

const PdfPreview = ({ pdfSrc, className = "", size = 200 }) => {
  const canvasRef = useRef();
  const isMounted = useIsMounted();
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (pdfSrc && isMounted) {
        /*const pdfjsLib = await import("pdfjs-dist/build/pdf");
        const pdfjsWorker = await import("pdfjs-dist/build/pdf.worker.entry");
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;*/
        await sleepUntil(() => window.pdfjsLib, 5000, 200);
        const { pdfjsLib } = window;
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.269/pdf.worker.mjs";

        const loadingTask = pdfjsLib.getDocument(pdfSrc);
        loadingTask.promise
          .then(
            function (pdf) {
              // Fetch the first page
              const pageNumber = 1;
              pdf.getPage(pageNumber).then(function (page) {
                const viewport = page.getViewport({ scale: 1 });

                // Prepare canvas using PDF page dimensions
                const canvas = canvasRef.current;
                const context = canvas.getContext("2d");
                const scale = (size * window.devicePixelRatio) / viewport.width;
                const scaledViewport = page.getViewport({ scale: scale });

                // Render PDF page into canvas context
                const renderContext = {
                  canvasContext: context,
                  viewport: scaledViewport
                };
                const renderTask = page.render(renderContext);
                renderTask.promise.then(function () {
                  setImageLoaded(true);
                });
              });
            },
            function (reason) {
              // PDF loading error
              console.error("PdfPreview error", reason);
            }
          )
          .catch(e => console.error("PdfPreview error", e));
      }
    };
    run();
  }, [pdfSrc, isMounted, size]);

  return (
    <>
      <Helmet>
        <script
          src="//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.269/pdf.mjs"
          type="module"
        />
      </Helmet>
      <div
        className={className}
        style={{
          display: "block",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          height: "100%",
          width: "100%",
          background: "#eee"
        }}
      >
        <motion.canvas
          width={size * window.devicePixelRatio}
          height={size * window.devicePixelRatio}
          ref={canvasRef}
          initial={{ opacity: 0 }}
          animate={{ opacity: imageLoaded ? 1 : 0 }}
          transition={{ duration: 1 }}
          style={{
            display: "block",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            aspectRatio: "1/1"
          }}
        />
      </div>
    </>
  );
};

export default PdfPreview;
